import { Link } from "react-router-dom";
import { LOGO_TRANSPARENT } from "@/lib/logoData";

/**
 * Brand mark for NEUROMATEMÁTICAS JASQ®.
 *
 * Variants:
 *  - "full"  → logo + texto (default)
 *  - "mark"  → solo el cerebro/iso
 */
export default function Logo({ variant = "full", size = 40, withTagline = false, asLink = false }) {
  const mark = (
    <div className="flex items-center gap-2" style={{ lineHeight: 1 }}>
      <img
        src={LOGO_TRANSPARENT}
        alt="NEUROMATEMÁTICAS JASQ"
        className="object-contain select-none shrink-0"
        style={{ height: size * 1.5, width: "auto" }}
        draggable={false}
      />
      {variant === "full" && (
        <div className="flex flex-col leading-none min-w-0">
          <span className="font-display font-extrabold text-[#1F2547] text-[13px] sm:text-sm tracking-tight truncate">
            NEURO<span className="text-[#F5B82E]">matemáticas</span>
          </span>
          <span className="font-display font-bold text-[10px] tracking-[0.14em] text-[#6E7591] truncate">
            <span className="text-[#D63384]">J</span>
            <span className="text-[#3FA84D]">A</span>
            <span className="text-[#2C49A0]">S</span>
            <span className="text-[#F5B82E]">Q</span>
            <span className="text-[#6E7591]"> ®</span>
            {withTagline ? " · Aprende sintiendo" : ""}
          </span>
        </div>
      )}
    </div>
  );
  if (asLink) return <Link to="/" className="inline-flex" data-testid="brand-logo">{mark}</Link>;
  return mark;
}
